(() => {
  const init = () => {
    const section = document.querySelector('#MainContent > .shopify-section:first-child [data-product-hero-04]');
    if (!section || section.dataset.heroChecked04) return;
    section.dataset.heroChecked04 = 'true';
    if (section.getAttribute('data-product-hero-04') !== 'auto') return;
    const source = section.getAttribute('data-hero-preview-04');
    if (!source) return;
    const key = 'product-hero-04:' + source;
    const apply = value => {
      if (section.getAttribute('data-product-hero-04') !== 'auto') return;
      section.setAttribute('data-product-hero-04', value);
      section.removeAttribute('data-hero-pending-04');
      window.dispatchEvent(new Event('resize'));
    };
    try {
      const cached = sessionStorage.getItem(key);
      if (cached === 'full' || cached === 'transparent') { apply(cached); return; }
    } catch {}
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = canvas.height = 48;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        context.drawImage(image, 0, 0, 48, 48);
        const pixels = context.getImageData(0, 0, 48, 48).data;
        let transparent = 0;
        for (let i = 3; i < pixels.length; i += 4) if (pixels[i] < 245) transparent++;
        const value = transparent > 4 ? 'transparent' : 'full';
        apply(value);
        try { sessionStorage.setItem(key, value); } catch {}
      } catch { apply('unchanged'); }
    };
    image.onerror = () => { apply('unchanged'); };
    image.src = source;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
